
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/system/screen-readers",
      function () {
        return require("private-next-pages/system/screen-readers.js");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/system/screen-readers"])
      });
    }
  